<div [loadable]="data$">
  <ng-container *ngIf="resource$ | async as resource">
    <div *ngIf="options$ | async as options" class="tw-font-dm-sans">
      <div class="sm:tw-hidden">
        <label for="Tab" class="tw-sr-only">Tab</label>

        <select id="Tab" class="tw-w-full tw-rounded-md tw-border-gray-200 tw-font-dm-sans" *ngIf="selectedOption$ | async as selectedOption">
          <option *ngFor="let option of options" (click)="selectLeaderboard(option)" [ngClass]="{
              'tw-bg-apicuron-purple tw-text-white tw-font-bold':
                option.leaderboard === selectedOption.leaderboard,
              'tw-border-t tw-border-r tw-border-gray-500':
                option.leaderboard != selectedOption.leaderboard
            }">
            {{ option.leaderboard }}
          </option>
        </select>
      </div>

      <div class="tw-hidden sm:tw-block">
        <div class="tw-border-b tw-border-gray-200">
          <nav class="tw--mb-px tw-flex tw-gap-1" *ngIf="selectedOption$ | async as selectedOption">
            <button *ngFor="let option of options" (click)="selectLeaderboard(option)" [ngClass]="{
				'tw-bg-apicuron-bright-purple tw-text-white': option.leaderboard === selectedOption.leaderboard,
				'tw-bg-white tw-text-gray-700 hover:tw-text-gray-800 tw-shadow-inner': option.leaderboard != selectedOption.leaderboard,
				}" class="shrink-0 tw-border tw-border-transparent tw-rounded-t-lg tw-p-1 tw-text-sm tw-font-bold
              tw-transition-all tw-duration-200 tw-ease-in">
              {{ option.label }}
            </button>
          </nav>
        </div>
      </div>
    </div>
    <div *ngIf="selectedOption$ | async as selectedOption"
      class="tw-bg-white tw-rounded-b-lg tw-rounded-r-lg tw-shadow-md tw-p-1">
      <ng-container [ngSwitch]="selectedOption.leaderboard">
        <ng-container *ngSwitchCase="'total-leaderboard'" class="tw-p-1 xl:tw-p-2">
          <total-leaderboard [resource]="resource" [columns]="selectedOption.columns"></total-leaderboard>
        </ng-container>
        <ng-container *ngSwitchCase="'weekly-leaderboard'">
          <weekly-leaderboard [resource]="resource" [columns]="selectedOption.columns"></weekly-leaderboard>
        </ng-container>

        <ng-container *ngSwitchCase="'monthly-leaderboard'">
          <monthly-leaderboard [resource]="resource" [columns]="selectedOption.columns"></monthly-leaderboard>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>